import { useSearchParams } from "react-router-dom";
import { parseISO } from "date-fns";
import moment, { GetStartAndEndOfCurrentWeek } from "../../../utils/moment";
import { useFetchProviderUpcomingSessions } from "../../providers/hooks/providers.queries";
import { useAppSelector } from "../../../hooks/useRedux";
import { useFetchWeeklySchedule } from "../../schedule/hooks/schedule.queries";
import { isDateInCurrentWeek } from "../../../utils/helpers";

export default function useGetWeekViewData() {
    const { startOfWeek, endOfWeek } = GetStartAndEndOfCurrentWeek();
    const { practice } = useAppSelector((state) => state.userPractice);
    const [searchParams] = useSearchParams();

    const startOfWeekFallback = moment()
        .startOf("isoWeek")
        .clone()
        .startOf("isoWeek")
        .format("YYYY-MM-DD");

    const endOfWeekFallback = moment()
        .startOf("isoWeek")
        .clone()
        .endOf("isoWeek")
        .format("YYYY-MM-DD");

    const startOfWeekOthers =
        searchParams.get("from_date") || startOfWeekFallback;
    const endOfWeekOthers = searchParams.get("to_date") || endOfWeekFallback;
    const clientIdsFilter = searchParams.getAll("client_ids[]") || [];

    const isCurrentWeek = isDateInCurrentWeek(parseISO(startOfWeekOthers));

    const currentWeek = useFetchProviderUpcomingSessions(
        practice?.provider_id || "",
        {
            from_date: startOfWeek,
            to_date: endOfWeek,
        },
        Boolean(practice?.provider_id) && isCurrentWeek
    );

    const otherWeeks = useFetchWeeklySchedule(
        {
            client_ids: clientIdsFilter,
            provider_ids: [practice?.provider_id || ""],
            from_date: startOfWeekOthers,
            to_date: endOfWeekOthers,
        },
        !isCurrentWeek
    );

    return {
        loading: isCurrentWeek ? currentWeek.isLoading : otherWeeks.isLoading,
        data: isCurrentWeek ? currentWeek.data : otherWeeks.data,
        error: isCurrentWeek ? currentWeek.error : otherWeeks.error,
        isSuccess: isCurrentWeek ? currentWeek.isSuccess : otherWeeks.isSuccess,
    };
}
